import axios from "axios";
import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import Section from "../components/Section";
import { CONTACT_INFO } from "./constants";

const Contact = () => {
  const [formData, setFormData] = useState(new FormData());

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!(formData.name && formData.email && formData.message)) {
      alert(CONTACT_INFO.errorMessage);
      return;
    }

    alert(CONTACT_INFO.alertMessage.replace("{name}", formData.name));
    // try {
    //   axios.post(CONTACT_INFO.formspreeUrl, formData, {
    //     Accept: "application/json",
    //   });
    // } catch (e) {
    //   console.log(e);
    // }
    setFormData({});
  };

  return (
    <Section id="contact" title="Contact">
      <div className="row justify-content-between">
        <div className="col-md-5 order-last order-lg-first" data-aos="fade-up">
          <div className="subheading mb-3">I'd love to hear from you</div>
          <form>
            <div className="form-group pt-1 pb-2">
              <label htmlFor="username">Full Name</label>
              <input
                type="text"
                className="form-control"
                id="username"
                name="name"
                aria-describedby="emailHelp"
                placeholder={CONTACT_INFO.placeholders.name}
                value={formData.name || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-group pt-2 pb-3">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                className="form-control"
                name="email"
                id="email"
                aria-describedby="emailHelp"
                placeholder={CONTACT_INFO.placeholders.email}
                value={formData.email || ""}
                onChange={handleChange}
              />
            </div>
            <div className="form-group pb-4">
              <label htmlFor="userMessage">Message</label>
              <textarea
                className="form-control"
                id="userMessage"
                name="message"
                rows="3"
                placeholder={CONTACT_INFO.placeholders.message}
                value={formData.message || ""}
                onChange={handleChange}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </form>
        </div>
        <div className="col-md-6 mb-5 mb-lg-0" data-aos="fade-up">
          <div className="subheading mb-3">Reach out to me directly</div>
          <div className="contact-direct">
            <div className="row">
              <div className="col-sm-6">
                <div className="item">
                  <span>
                    <ImLocation />
                  </span>
                  <p>{CONTACT_INFO.location}</p>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="item">
                  <span>
                    <FaPhoneAlt />
                  </span>
                  <p>{CONTACT_INFO.phone}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3015.4201639143366!2d-73.11413511677522!3d40.906532451866035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e83f4a44538fd1%3A0xbcbda17c27b1a641!2sChapin%20Apartment%20H%2C%20Patriots%20Rd%2C%20Stony%20Brook%2C%20NY%2011794!5e0!3m2!1sen!2sus!4v1728145153477!5m2!1sen!2sus"
              width="600"
              height="450"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <p className="py-3 m-0 mt-5 text-center text-secondary">
        Made with ❤ by Ambalika
      </p>
    </Section>
  );
};

export default Contact;
